import { render, staticRenderFns } from "./OutputNew.vue?vue&type=template&id=1895a616"
import script from "./OutputNew.vue?vue&type=script&lang=js"
export * from "./OutputNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports